import PropTypes from 'prop-types'
import { Heading } from '@pretamanger/component-library'
import { image as imageType, product } from '@proptypes'
import LocaleLink from '#src/common/components/locale-link'
import { DietaryBadge, NewBadge } from '#src/common/components/badge'
import { isNew, strictSlugify } from '#src/products/util'
import { SubCategoryTitle } from './subcategory-title'
import {
  CardContainer,
  CardLink,
  ContainerTitle,
  ProductCard,
  ProductListWrapper
} from './product-list-non-transactional.styles'
import { getImage } from '#src/common/components/image/get-image'
import { fireEvent } from '#lib/events'
import { SELECT_ITEM } from '#lib/events/topics'

const ProductListNonTransactional = ({
  name,
  products,
  placeholder,
  selectedCategory,
  selectedSubCategory
}) => {
  const categoryName =
    selectedSubCategory?.name?.toLowerCase() === 'all'
      ? selectedCategory.name
      : selectedSubCategory.name
  return (
    <ProductListWrapper data-testid='product-list-non-transactional'>
      {name ? (
        <ContainerTitle>
          <SubCategoryTitle count={products.length} name={name} />
        </ContainerTitle>
      ) : null}
      <CardContainer>
        {products.map(product => {
          const imageBadges = [
            isNew(product.newUntil) && (
              <NewBadge key={`${product.id}-badge-new`} />
            )
          ].filter(badge => badge)

          const dietaryBadge = [
            (product.suitableForVegans && (
              <DietaryBadge key={`${product.id}-badge-vg`} diet='vg' />
            )) ||
              (product.suitableForVegetarians && (
                <DietaryBadge key={`${product.id}-badge-v`} diet='v' />
              ))
          ].filter(badge => badge)

          const wrappingLink = `productLink-${product.id}`

          const onSelectItem = () => {
            fireEvent(SELECT_ITEM, {
              product,
              name,
              selectedCategory,
              selectedSubCategory
            })
          }

          return (
            <ProductCard
              key={product.id}
              cardBadges={dietaryBadge}
              image={getImage({
                img: product.image ?? placeholder,
                useProductWrapper: true
              })}
              imageBadges={imageBadges}
              wrappingLink={wrappingLink}
              data-testid='product-card'
            >
              <LocaleLink
                href='/products/[sku]/[name]'
                as={`/products/${product.sku}/${encodeURIComponent(
                  strictSlugify(product.name)
                )}?category=${categoryName}`}
                replace
              >
                <CardLink
                  id={wrappingLink}
                  data-testid='product-link'
                  onClick={onSelectItem}
                >
                  <Heading level='h3' styleOverride='headingBodyBase'>
                    {product.name}
                  </Heading>
                </CardLink>
              </LocaleLink>
            </ProductCard>
          )
        })}
      </CardContainer>
    </ProductListWrapper>
  )
}

ProductListNonTransactional.propTypes = {
  name: PropTypes.string,
  placeholder: imageType.isRequired,
  products: PropTypes.arrayOf(product)
}

ProductListNonTransactional.defaultProps = {
  name: '',
  products: []
}

export default ProductListNonTransactional
